<ngx-smart-modal
  #resetWidgetConfigDialog
  [class]="modalCls"
  [identifier]="'resetWidgetConfigDialog'"
  [style]="modalStyle"
>
  <div class="body">
    <div class="content">
      <h2>Reset changes?</h2>
      <p class="sub-title">Do you want to reset the widget back to it’s default state?</p>
    </div>
  </div>

  <div class="popup-footer">
    <div class="col-12 text-center">
      <button class="mr-4" (click)="closeAlert()">Cancel</button>
      <button class="positive" (click)="resetWidgetConfig()">Confirm</button>
    </div>
  </div>
</ngx-smart-modal>
